module.exports = __webpack_public_path__ + "img/menu-templates.dbbe3323.svg";